export default __webpack_public_path__ + "static/6836-bced2ed07432d248821d5859a93aa7dc.jpg";